import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withSagas } from 'decorators/Sagas/Sagas';
import { CmsOffer } from 'features/Offer/CmsOffer';
import { selectPagePromotion } from 'redux/modules/page';
import { decorateWith, withName } from 'helpers/decorator';
import { watchOfferBannerSaga } from './OfferBanner.saga';

export const DEFAULT_CMS_SLUG = 'offer-banner-default';

export const OfferBannerUnwrapped = ({ promoAlias }) => {
  const cmsContentSlugs = [DEFAULT_CMS_SLUG];
  if (promoAlias) {
    cmsContentSlugs.unshift(`offer-banner-${promoAlias}`);
  }
  return (
    <div className="OfferBanner">
      <CmsOffer cmsContentSlugs={cmsContentSlugs} />
    </div>
  );
};

export const mapStateToProps = state => ({
  promoAlias: selectPagePromotion(state),
});

OfferBannerUnwrapped.propTypes = {
  promoAlias: PropTypes.string,
};

export const OfferBanner = decorateWith(
  connect(mapStateToProps),
  withSagas({
    watch: watchOfferBannerSaga,
  }),
  withName('OfferBanner')
)(OfferBannerUnwrapped);
